import React, { useEffect, useState } from 'react';
import { useAuth } from '../../context/AuthContext';

const SessionExpiredNotification = () => {
  const { sessionExpired, setSessionExpired } = useAuth();
  const [progress, setProgress] = useState(100);
  const [timeLeft, setTimeLeft] = useState(3);

  useEffect(() => {
    if (sessionExpired) {
      // شروع progress bar از 100% و کاهش تا 0%
      const startTime = Date.now();
      const duration = 3000; // 3 ثانیه
      
      const progressInterval = setInterval(() => {
        const elapsed = Date.now() - startTime;
        const remaining = Math.max(0, 100 - (elapsed / duration) * 100);
        const timeRemaining = Math.ceil((duration - elapsed) / 1000);
        
        setProgress(remaining);
        setTimeLeft(timeRemaining);
        
        if (remaining <= 0) {
          clearInterval(progressInterval);
        }
      }, 50); // هر 50 میلی‌ثانیه آپدیت

      // پاک کردن sessionExpired بعد از 3 ثانیه
      const timer = setTimeout(() => {
        setSessionExpired(false);
        setProgress(100);
        setTimeLeft(3);
      }, 3000);

      return () => {
        clearTimeout(timer);
        clearInterval(progressInterval);
      };
    }
  }, [sessionExpired, setSessionExpired]);

  if (!sessionExpired) {
    return null;
  }

  return (
    <div className="fixed top-4 right-4 z-50 max-w-sm w-full">
      <div className="bg-red-50 border border-red-200 rounded-lg shadow-lg p-4">
        <div className="flex items-start">
          <div className="flex-shrink-0">
            <svg className="w-5 h-5 text-red-400" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
            </svg>
          </div>
          <div className="mr-3 flex-1">
            <h3 className="text-sm font-medium text-red-800">
              انقضای جلسه
            </h3>
            <div className="mt-2 text-sm text-red-700">
              <p>
                جلسه شما منقضی شده است. در حال انتقال به صفحه ورود...
              </p>
              <p className="text-xs text-red-600 mt-1">
                {timeLeft} ثانیه باقی‌مانده
              </p>
              {/* Progress Bar */}
              <div className="mt-2 w-full bg-red-200 rounded-full h-1">
                <div 
                  className="bg-red-500 h-1 rounded-full transition-all duration-50 ease-linear"
                  style={{ width: `${progress}%` }}
                ></div>
              </div>
            </div>
          </div>
          <div className="mr-auto pr-0">
            <button
              onClick={() => setSessionExpired(false)}
              className="inline-flex text-red-400 hover:text-red-600 focus:outline-none focus:text-red-600"
            >
              <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SessionExpiredNotification; 